import { IKnmPmFormResultDecision } from 'KnmPmPackage/MainModule/interfaces/IKnmPmFormResultDecision';
import { IDecisionOrganizationForm } from 'DecisionPackage/MainModule/interfaces/IDecisionOrganizationForm';
import { IGeneralResultDecision } from 'KnmErknmPackage/ErkmAgreementsModule/interfaces/IGeneralResultDecision';

import { IKnmErknmFormResultDecision } from '../interfaces/IKnmErknmFormResultDecision';

export const getGeneralResultDecisionOptions = (
  resultDecisionsKnm?: IKnmErknmFormResultDecision[],
  resultDecisionsPm?: IKnmPmFormResultDecision[],
  organizationDecision?: IDecisionOrganizationForm,
): IGeneralResultDecision[] | undefined => {
  const resultDecisions: IGeneralResultDecision[] = [];

  if (resultDecisionsKnm) {
    resultDecisionsKnm.forEach(rd =>
      resultDecisions.push({
        guid: rd.guid || '',
        kindDecision: rd.kindDecision,
        number: rd.numberDecision,
        organization: rd.organization,
        status: rd.status,
        signed: rd.signed,
        violatedMandatoryRequirements: rd.violatedMandatoryRequirements,
        date: rd.dateDecision,
      }),
    );
  }

  if (resultDecisionsPm) {
    resultDecisionsPm.forEach(rd =>
      resultDecisions.push({
        guid: rd.guid || '',
        kindDecision: rd.kindDecision,
        number: rd.number,
        // @ts-ignore
        organization: {
          ...rd.organization,
          addressFns: '',
          isAutocomplete: false,
          guid: '',
          isDocumentOrganization: false,
          listId: '',
          subjectType: rd.organization?.subjectTypePm,
          isForeignSubjectAgencyNotRegistredInRf: undefined,
          epguNotifications: [],
        },
        status: rd.status,
        signed: rd.signed,
        violatedMandatoryRequirements: rd.violatedMandatoryRequirements,
        date: rd.date,
      }),
    );
  }

  if (organizationDecision?.resultDecisions?.length) {
    organizationDecision?.resultDecisions.forEach(rd =>
      resultDecisions.push({
        guid: rd.guid || '',
        kindDecision: rd.kind,
        number: rd.number,
        // @ts-ignore
        organization: {
          ...organizationDecision,
          addressFns: '',
          isAutocomplete: false,
          guid: '',
          isDocumentOrganization: false,
          listId: '',
          subjectType: organizationDecision.organizationType,
          isForeignSubjectAgencyNotRegistredInRf: undefined,
          epguNotifications: [],
        },
        status: rd.status,
        signed: rd.signed,
        violatedMandatoryRequirements: rd.eliminatedMandatoryRequirements,
        date: rd.date,
      }),
    );
  }

  return resultDecisions;
};
